import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DashboardData, DashboardPayload, MedicineReportPayload } from 'src/interfaces/dashboard';
import { AuthService } from './auth.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  baseUrl: string = environment.api.baseUrl;

  constructor(
    private _http: HttpClient,
    private _auth: AuthService,
    private _utilsService: UtilsService
  ) {}

  /** Always await fresh headers — constructor cannot await; resolver may run before a fire-and-forget `then` completes. */
  private async requestHeaders(): Promise<HttpHeaders> {
    return this._auth.generateRequestHeaders();
  }

  async getDashboardData(payload: DashboardPayload): Promise<DashboardData | null> {
    try {
      const headers = await this.requestHeaders();
      let ordersBatchesResponse = await this._http
        .post<any>(`${this.baseUrl}/dashboard`, payload, { headers })
        .toPromise();

      let medicineResponse = await this._http
        .post<any>(`${this.baseUrl}/report/medicine`, payload, { headers })
        .toPromise();

      const data: DashboardData = {
        medicine: medicineResponse.data,
        batches: ordersBatchesResponse.data.batches,
        orders: ordersBatchesResponse.data.orders
      }

      return data;

    } catch (error) {
      this._utilsService.showError(error);
      return null;
    }
  }


  async getOrdersData(payload: DashboardPayload) {
    try{
      const headers = await this.requestHeaders();
      const {data} = await this._http
        .post<any>(`${this.baseUrl}/dashboard`, payload, { headers })
        .toPromise();
      return data.orders;
    } catch (error) {
      this._utilsService.showError(error);
    }
  }

  async getBatchesData(payload: DashboardPayload) {
    try{
      const headers = await this.requestHeaders();
      const {data} = await this._http
        .post<any>(`${this.baseUrl}/dashboard`, payload, { headers })
        .toPromise();
      return data.batches;
    } catch (error) {
      this._utilsService.showError(error);
    }
  }

  async getMedicineData(payload: DashboardPayload) {
    try{
      const headers = await this.requestHeaders();
      const {data} = await this._http
        .post<any>(`${this.baseUrl}/report/medicine`, payload, { headers })
        .toPromise();
      return data;
    } catch (error) {
      this._utilsService.showError(error);
    }
  }


  async getMedicineDataInExcelFormat(payload: MedicineReportPayload) {
    try{
      const headers = await this.requestHeaders();
      const {data} = await this._http
        .post<any>(`${this.baseUrl}/report/medicine`, payload, { headers })
        .toPromise();
      return data.result;
    } catch (error) {
      this._utilsService.showError(error);
    }
  }

  async diffReportStocktake(payload: any): Promise<any | null> {
    try {
      const headers = await this.requestHeaders();
      const { message, data } = await this._http
        .post<any>(`${this.baseUrl}/stocktake/report/difference`, payload, { headers })
        .toPromise();
      return data;
    } catch (error) {
      this._utilsService.showError(error);

      return null;
    }
  }

  
}
